export default __webpack_public_path__ + "static/media/11.4f8777a8.jpg";